import { Component } from '@angular/core';

@Component({
    selector: 'app-password',
    templateUrl: './password.component.html',
    standalone: false,
})
export class PasswordComponent {
    constructor() {}
}
